export default __webpack_public_path__ + "static/media/151-hand-gesture.2136c9fb.png";